import {
  CONTACT_EMAIL,
  CONTACT_PHONE_DISPLAY,
  contactEmailHref,
  contactPhoneHref,
  contactWhatsAppHref,
} from './contact';

/** Phone (call / WhatsApp) and email, as links - for the public pages. */
export function ContactDetails({ inline = false }: { inline?: boolean }) {
  const items = [
    <span key="phone">
      Phone: <a href={contactPhoneHref}>{CONTACT_PHONE_DISPLAY}</a> (
      <a href={contactWhatsAppHref} target="_blank" rel="noreferrer">
        WhatsApp
      </a>
      )
    </span>,
    <span key="email">
      Email: <a href={contactEmailHref()}>{CONTACT_EMAIL}</a>
    </span>,
  ];
  return inline ? (
    <span style={{ display: 'inline-flex', gap: 'var(--space-3)', flexWrap: 'wrap' }}>{items}</span>
  ) : (
    <span style={{ display: 'grid', gap: 'var(--space-1)' }}>{items}</span>
  );
}
